import { Badge as MantineBadge, BadgeProps as MantineBadgeProps } from "@mantine/core";
import styles from "./styles.module.css";
import { ReactNode } from "react";

export const badgeColor = {
  primary: "primary",
  completed: "completed",
  warning: "warning",
  error: "error",
  success: "success",
  gray: "gray",
};

export interface BadgeProps extends MantineBadgeProps {
  children?: ReactNode;
  color?: string;
  noTextTransform?: boolean;
}

const Badge = ({ children, color = "var(--color-processing-primary)", noTextTransform, ...props }: BadgeProps) => {
  let bgColor = "";
  switch (color) {
    case "primary":
      bgColor = "var(--color-success-primary)";
      break;
    case "completed":
      bgColor = "var(--color-completed-primary)";
      break;
    case "warning":
      bgColor = "var(--color-warning-primary)";
      break;
    case "error":
      bgColor = "var(--color-negate-primary)";
      break;
    case "success":
      bgColor = "var(--color-completed-primary)";
      break;
    case "gray":
      bgColor = "var(--color-background-tertiary)";
      break;
    default:
      bgColor = `${color}`;
  }

  return (
    <MantineBadge
      {...props}
      className={styles.badgeRoot}
      style={{
        textTransform: noTextTransform ? "capitalize" : "uppercase",
        ...props.style,
      }}
      vars={() => ({
        root: {
          "--badge-bg": bgColor,
          "--badge-fz": "12px",
        },
      })}
    >
      {children}
    </MantineBadge>
  );
};

export default Badge;
